/**
 * genPromo — porta exata de [application.js:594]: codifica {email, prices?} no link de
 * checkout (base64 → invertido → base64, com 3 hex aleatórios em cada ponta).
 */
function genHex(size: number): string {
  let out = '';
  for (let i = 0; i < size; i++) out += Math.floor(Math.random() * 16).toString(16);
  return out;
}

export function genPromo(pure: Record<string, unknown>): string {
  try {
    const json = JSON.stringify(pure);
    let transform = btoa(json);
    let reverse = '';
    for (let i = transform.length - 1; i >= 0; i--) reverse += transform[i];
    transform = btoa(reverse.replace(/=/g, ''));
    return genHex(3) + transform.replace(/=/g, '') + genHex(3);
  } catch {
    return '';
  }
}
